import {BehaviorSubject, combineLatest, from} from 'rxjs';
import {filter, map, distinctUntilChanged} from 'rxjs/operators';
import {configApi} from '@px/api/config';
import {wwData$} from './worker-data';

export const fiat$ = new BehaviorSubject('USD'); // 兑换货币
export const fiatSign$ = new BehaviorSubject('$'); // 法币符号
const fiatConfigs$ = new BehaviorSubject([]); // 所有法定货币配置

export function loadBaseConfig() {
  const configs = fiatConfigs$.getValue();
  if (configs.length > 0) {
    return;
  }
  from(configApi.getFiatConfig())
    .pipe(filter(({error}) => !error))
    .subscribe(({data}) => fiatConfigs$.next(data.fiat));
}

fiat$.pipe(distinctUntilChanged()).subscribe((currency) => wwData$.next({type: 'update-fiat', currency}));

combineLatest([fiat$, fiatConfigs$])
  .pipe(
    map(([fiat, configs]) => configs.find((o) => fiat === o.code)),
    filter(Boolean),
    map((config) => config.sign),
    filter(Boolean),
    distinctUntilChanged()
  )
  .subscribe((sign) => fiatSign$.next(sign));
